export const FETCH_SUBSIDY_FLOW = "FETCH_SUBSIDY_FLOW";
export const FETCH_SUBSIDY_FLOW_SUCCESS = 'FETCH_SUBSIDY_FLOW_SUCCESS';
export const FETCH_SUBSIDY_FLOW_FAILURE = 'FETCH_SUBSIDY_FLOW_FAILURE';
export const saveSubsidyFlowData = (data) => ({
    type: FETCH_SUBSIDY_FLOW_SUCCESS,
    payload: data
})

